export default {
  widgets: {
    clientCommonFilesPanel: {
      title: 'Qoʻshimcha fayllar',
      addCommonFileTitle: 'Qoʻshimcha fayl yuklash',
    },
  },
};
